import { put, takeEvery, select, call } from "redux-saga/effects";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  SET_GRAPH_NODES_LIST,
  GET_DATAMAP_NODES,
  SET_DATAMAP_DETAILS,
  SET_DATAMAP_LOADER,
  SET_DATAMAP_TOOLTIP_DETAILS,
  SET_DATAMAP_TOOLTIP_LOADER,
  SET_DATAMAP_MULTI_TOOLTIP_LOADER,
  ENABLE_NODE_TOOLTIP,
  GET_DATAMAP_NODE_TOOLTIP,
  SET_DATAMAP_MULTI_TOOLTIP_DATA,
  SET_TOOL_TIP_DATA,
  SET_LOADER,
  SET_PUBLIC_DB_ACCESS_DETAILS,
  FILE_REVOKE_ACCESS,
  fileRevokeAccessAPI,
  FETCH_ALL_FIELDS_DATA_REQUEST,
  FETCH_SENSITIVE_DATA_FIELDS_REQUEST,
  SET_FILE_REVOKE_LIST,
  DATA_MAP_SNACKBAR_MESSAGE,
  userFileRevokeAccessAPI,
  USER_FILE_REVOKE_ACCESS,
  DOMAIN_WIDE_REVOKE_ACCESS,
  domainWideRevokeAccessAPI,
  GET_USER_AUDIT_TRAIL,
  getUserAuditTrailApi,
  SET_USER_AUDIT_TRAIL,
  GET_DATA_SOURCE_AUDIT_TRAIL,
  getDataSourceAuditTrailApi,
  SET_DATA_SOURCE_AUDIT_TRAIL,
} from "../constants/constants.js";
import { getCubejsApi } from "../../../src/components/common/Dashboard/cubejs-util";

import {
  getNodeProperties,
  getNodePositions,
  getPublicDBAccessDetails,
} from "../../components/shared/dataMapUtilities";

import { dataMapRender } from "../../controllers/dataMapController";
import { SET_DATA_TAG_NODES_DATA } from "../../features/Data Tag/DataTagConstants.js";

function* processDataMapResponse(dataMapNodes, filterId) {
  // generate edges and nodes and return
  let ReducerData = yield select();
  const { nodePositions } = ReducerData.nodePositions;

  const nodesObj = dataMapRender(dataMapNodes, nodePositions);
  getNodeProperties(nodesObj);
  getNodePositions(nodesObj, nodePositions);
  const publicDBAccessDetails = getPublicDBAccessDetails(nodesObj);
  yield put({
    type: SET_GRAPH_NODES_LIST,
    payload: nodesObj,
    filterId: filterId,
  });
  yield put({
    type: SET_PUBLIC_DB_ACCESS_DETAILS,
    payload: publicDBAccessDetails,
  });
}

//  To get cube data map data
async function getCubeDataMapData(queryString) {
  const cubejsApi = getCubejsApi();
  const resultSet = await cubejsApi.load(queryString);
  const response = resultSet.rawData();
  if (response && response.length > 0) {
    const nodeIds = response.map(function (item) {
      return item["NodesOfApplication.nodeId"];
    });
    return nodeIds;
  }
}

function* getNodeTooltipData(action) {
  const nodeId = action.payload.node.id;
  const options = {
    method: "GET",
    url: `${GET_DATAMAP_NODE_TOOLTIP}/${nodeId}`,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      yield put({
        type: SET_DATAMAP_MULTI_TOOLTIP_DATA,
        payload: {
          data: res.data,
          selectedHoverNode: action.payload.node,
          loaderStatus: false,
          posiCoord: action.payload.posiCoord,
        },
      });
    }
  } catch (error) {
    yield put({
      type: SET_DATAMAP_TOOLTIP_LOADER,
      payload: {
        selectedHoverNode: action.payload.node,
        loaderStatus: false,
        posiCoord: action.payload.posiCoord,
      },
    });
  }
}

function* getNodesList(action) {
  const nodeIds = yield call(getCubeDataMapData, action.payload.queryString);
  yield* getDataMapInfo(nodeIds, action.payload.filterId);
}

function* enableNodeTooltip(payload) {
  yield put({
    type: SET_DATAMAP_MULTI_TOOLTIP_LOADER,
    payload: { loaderStatus: true, ...payload.action },
  });
  yield* getNodeTooltipData({
    payload: {
      node: payload.action.selectedHoverNode,
      posiCoord: payload.action.posiCoord,
    },
  });
}

function* getDataMapInfo(action, filterId) {
  if (action && action.length) {
    const options = {
      method: "POST",
      url: `${GET_DATAMAP_NODES}`,
      headers: getAxiosHeaders(true),
      data: { nodeIds: action },
    };
    try {
      const res = yield getService(options);
      if (res && res.status === 200) {
       yield put({
          type: SET_DATA_TAG_NODES_DATA,
          payload: res.data?.nodes || [],
       });
        yield put({
          type: SET_DATAMAP_DETAILS,
          payload: yield processDataMapResponse(res.data, filterId),
        });
      }
      yield put({
        type: SET_DATAMAP_LOADER,
        payload: false,
      });
    } catch (error) {
      yield put({
        type: SET_DATAMAP_LOADER,
        payload: false,
      });
    }
  } else {
    // nothing to load
    yield put({
      type: SET_DATAMAP_LOADER,
      payload: false,
    });
  }
}

function* getTooltipData(action) {
  yield put({
    type: SET_LOADER,
    payload: true,
  });
  const nodeId = action.payload;
  const options = {
    method: "GET",
    url: `${GET_DATAMAP_NODE_TOOLTIP}/${nodeId}`,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      yield put({
        type: SET_TOOL_TIP_DATA,
        payload: res.data,
      });
    }
  } catch (error) {
    yield put({
      type: SET_LOADER,
      payload: false,
    });
  }
}

function* fileRevokeAccess(action) {
  yield put({
    type: SET_LOADER,
    payload: true,
  });
  const { dataSourceId, data, enterpriseActorId, loc } = action.payload;
  const options = {
    method: "PUT",
    url: loc === "accessRights" ? userFileRevokeAccessAPI(dataSourceId, enterpriseActorId) : fileRevokeAccessAPI(dataSourceId),
    headers: getAxiosHeaders(true),
    data: data,
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 204) {
      yield put({
        type: DATA_MAP_SNACKBAR_MESSAGE,
        payload: {
          apiSuccess: "success",
          message: "Initiating File Access Revoke",
        },
      });
      yield put({ type: SET_FILE_REVOKE_LIST, payload: [] });
      yield put({ type: FETCH_SENSITIVE_DATA_FIELDS_REQUEST });
      yield put({ type: FETCH_ALL_FIELDS_DATA_REQUEST });
    } else {
      yield put({
        type: DATA_MAP_SNACKBAR_MESSAGE,
        payload: {
          apiSuccess: "error",
          message: "File Access Revoke Failed to Start",
        },
      });
    }
  } catch (err) {
    yield put({
      type: DATA_MAP_SNACKBAR_MESSAGE,
      payload: {
        apiSuccess: "error",
        message: "File Access Revoke Failed to Start",
      },
    });
    console.log(err, "Access Revoked failed");
  } finally {
    yield put({
      type: SET_LOADER,
      payload: false,
    });
  }
}

function* userFileRevokeAccess(action) {
  const {dataSourceId, enterpriseActorId} = action.payload;
  const options ={
    method: "PUT",
    url: userFileRevokeAccessAPI(dataSourceId, enterpriseActorId),
    headers: getAxiosHeaders(true)
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 204) {
      console.log("success");
    }
  } catch (err) {
    console.log(err,"Something went wrong")
  } finally {
    console.log("call complete");
  }
}

function* domainWideRevokeAccess(action) {
  const {dataSourceId} = action.payload;
  const options ={
    method: "PUT",
    url: domainWideRevokeAccessAPI(dataSourceId),
    headers: getAxiosHeaders(true)
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 204) {
      console.log("success");
    }
  } catch (err) {
    console.log(err,"Something went wrong")
  } finally {
    console.log("call complete");
  }
}

function* getUserAuditTrail () {
  const options = {
    method: "GET",
    url: getUserAuditTrailApi(),
    headers: getAxiosHeaders(true)
  }
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res.data;
      yield put({type: SET_USER_AUDIT_TRAIL, payload: data});
    }
  } catch (err) {
    console.log(err)
  }
}

function* getDataSOurceAuditTrail() {
  const options = {
    method: "GET",
    url: getDataSourceAuditTrailApi(),
    headers: getAxiosHeaders(true)
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res.data;
      yield put({type: SET_DATA_SOURCE_AUDIT_TRAIL, payload: data});
    }
  }catch (err) {
    console.log(err)
  }
}

function* dataMapSaga() {
  yield takeEvery(ENABLE_NODE_TOOLTIP, enableNodeTooltip);
  yield takeEvery("GET_NODES_LIST", getNodesList);
  yield takeEvery("GET_DATAMAP_TOOLTIP_DATA", getTooltipData);
  yield takeEvery(FILE_REVOKE_ACCESS, fileRevokeAccess);
  yield takeEvery(USER_FILE_REVOKE_ACCESS, userFileRevokeAccess);
  yield takeEvery(DOMAIN_WIDE_REVOKE_ACCESS, domainWideRevokeAccess);
  yield takeEvery(GET_USER_AUDIT_TRAIL, getUserAuditTrail);
  yield takeEvery(GET_DATA_SOURCE_AUDIT_TRAIL, getDataSOurceAuditTrail);
}

export default dataMapSaga;
